export default __webpack_public_path__ + "static/media/research.a830b13c.jpg";